import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import './FAQSection.scss';

const FAQSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const faqs = [
    {
      question: 'What do I need to pick up work?',
      answer:
        "You will need to upload your BOC Certification, State Licensure, and Professional Liability Insurance. If you don't have an insurance policy, you can buy one through the Go4 app within minutes.",
    },
    {
      question: 'How do I schedule myself for work?',
      answer:
        'Find a job you like on the job feed and just click the apply button. Hiring organizations have seven days to respond, but you usually hear back within a day or two.',
    },
    {
      question: 'How do I get chosen to work?',
      answer: 'After you apply, the job poster will review your profile and accept you to work.',
    },
    {
      question: 'How do I get paid?',
      answer:
        'Payments are made by direct deposit to your bank account and arrive within 3-5 business days after the end of your shift.',
    },
  ];

  const toggleFAQ = index => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <article className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <dl className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}>
              <dt className="faq-question-header">
                <button
                  className="faq-question-button"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={expandedIndex === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span className="faq-question">{faq.question}</span>
                  <span className="faq-icon" aria-hidden="true"></span>
                </button>
              </dt>
              <Collapse isOpen={expandedIndex === index}>
                <dd className="faq-answer" id={`faq-answer-${index}`}>
                  {faq.answer}
                </dd>
              </Collapse>
            </div>
          ))}
        </dl>
      </article>
    </section>
  );
};

export default FAQSection;
